import React from 'react'
import { IMG_BASE_URL } from '../../../../config/Config'
import { useNavigate } from 'react-router-dom'

const Talk_To_Permium_Astrologer = (homeData) => {
  const navigate = useNavigate()
  const Talk_To_Permium_Astrologer_banner = homeData?.data?.home_mid_sliders
  const category = homeData?.data?.category || [];
  const gemstoneCategory = category?.find(cat => cat?.id === 1);
  const jewelleryCategory = category?.find(cat => cat?.id === 2);

  const navigationHandler = (navigation_type, url) => {
    
    const routeMap = {
      'book-pooja': '/pooja',
      'astrologer': '/astrologer-list',
      'pandit': '/pandit-list',
      'gemstone': gemstoneCategory?.slug ? `/${gemstoneCategory.slug}` : null,
      'jewellery': jewelleryCategory?.slug ? `/${jewelleryCategory.slug}` : null,
    };

    if (navigation_type === 'url' && url) {
      window.location.href = url
      return;
    }
    else if (routeMap[navigation_type]) {
      navigate(routeMap[navigation_type]);
      return;
    }
    else {
      console.warn(`Unrecognized navigation type: ${navigation_type}`);

      return; // Do nothing if navigation_type is unrecognized
    }
  };

  return (
    <div>
      <section className="wow fadeInUp" data-wow-duration="2s">
        <div
          className="">
          <div className="w-full cursor-pointer">
            <div onClick={() => navigationHandler(Talk_To_Permium_Astrologer_banner?.navigation_type, Talk_To_Permium_Astrologer_banner?.url)}>
              <img width="100%" src={`${IMG_BASE_URL}${Talk_To_Permium_Astrologer_banner?.image}`} className="w-full" alt={Talk_To_Permium_Astrologer_banner?.title} />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Talk_To_Permium_Astrologer